<template>
	<div class="min-h-screen bg-gray-50">
		<!-- css样式库 -->
		<link href="https://cdn.jsdelivr.net/npm/tailwindcss@2.2.19/dist/tailwind.min.css" rel="stylesheet">
		<!-- 图标库 -->
		<link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.15.4/css/all.min.css">

		<!-- 左侧导航 -->
		<aside class="fixed left-0 top-0 h-screen w-64 bg-white border-r border-gray-200 overflow-y-auto">
			<div class="p-4 border-b border-gray-200">
				<div class="flex items-center gap-2">
					<img :src="logoUrl" alt="API文档" class="w-8 h-8 object-cover" />
					<h1 class="text-xl font-bold text-gray-800">API
						{{ $t('language000189') }}
					</h1>
				</div>
			</div>

			<el-menu default-active="1" class="el-menu-vertical-demo">
				<el-menu-item index="1" @click="toggleCategory(1)">
					<span slot="title">
						<!-- 介绍 -->
						{{ $t('language000193')}}
					</span>
				</el-menu-item>

				<el-menu-item index="8" @click="toggleCategory(8)">
					<span slot="title">
						<!-- 流程示意图 -->
						{{ $t('language000307')}}
					</span>
				</el-menu-item>

				<el-menu-item v-show="false" index="4" @click="toggleCategory(2)">
					<span slot="title">
						<!-- AES加密 -->
						{{ $t('language000226')}}
					</span>
				</el-menu-item>

				<!-- 平台调用 -->
				<el-submenu index="2">
					<template slot="title">
						<span>API Service</span>
					</template>
					<el-menu-item-group>
						<el-menu-item index="1-1" @click="toggleCategory(3)">
							<!-- API Token -->
							API Token
						</el-menu-item>

						<el-menu-item index="1-3" @click="toggleCategory(11)">
							<!--刷新 API Token -->
							{{ $t('language000282') }} API Token
						</el-menu-item>

						<el-menu-item index="1-2" @click="toggleCategory(7)">
							<!-- 平台绑定设备 -->
							{{ $t('language000286') }}
						</el-menu-item>
					</el-menu-item-group>
				</el-submenu>

				<!-- 蓝牙命令 -->
				<el-submenu index="3">
					<template slot="title">
						<span slot="title">
							<!-- 设备 -->
							{{ $t('language000279') }}
						</span>
					</template>
					<el-menu-item-group>
						<el-menu-item index="2-1" @click="toggleCategory(4)">
							<!-- 设备 Token -->
							{{ $t('language000190')}}
						</el-menu-item>
						<el-menu-item index="2-4" @click="toggleCategory(9)">
							<!-- 解密蓝牙命令 -->
							{{ $t('language000317')}}
						</el-menu-item>
						<el-menu-item index="2-2" @click="toggleCategory(5)">
							<!-- 开锁命令 -->
							{{ $t('language000191')}}
						</el-menu-item>
						<el-menu-item index="2-3" @click="toggleCategory(6)">
							<!-- 关锁命令 -->
							{{ $t('language000192')}}
						</el-menu-item>
						<el-menu-item index="2-5" @click="toggleCategory(10)">
							<!-- 立即震动 -->
							{{ $t('language000461')}}
						</el-menu-item>
						<el-menu-item index="2-11" @click="toggleCategory(12)">
							<!-- 停止震动 -->
							{{ $t('language000462')}}
						</el-menu-item>
						<el-menu-item index="2-9" @click="toggleCategory(13)">
							<!-- 定时震动 -->
							{{ $t('language000314')}}
						</el-menu-item>
						<el-menu-item index="2-10" @click="toggleCategory(14)">
							<!-- 取消定时震动 -->
							{{ $t('language000460')}}
						</el-menu-item>
						<el-menu-item index="2-15" @click="toggleCategory(15)">
							<!-- 电击 -->
							{{ $t('language000311')}}
						</el-menu-item>
						<el-menu-item index="2-16" @click="toggleCategory(16)">
							<!-- 停止电击 -->
							{{ $t('language000512')}}
						</el-menu-item>
						<el-menu-item index="2-17" @click="toggleCategory(17)">
							<!-- 定时电击 -->
							{{ $t('language000312')}}
						</el-menu-item>
						<el-menu-item index="2-18" @click="toggleCategory(18)">
							<!-- 清除定时电击 -->
							{{ $t('language000379')}}
						</el-menu-item>
						<el-menu-item index="2-19" @click="toggleCategory(19)">
							<!-- 设置离线模式 -->
							{{ $t('language000517')}}
						</el-menu-item>
					</el-menu-item-group>
				</el-submenu>
			</el-menu>
		</aside>

		<!-- 主内容区 -->
		<main class="ml-64 p-8">
			<introduce v-show="isIntroduce" />
			<steps v-show="isSteps" />
			<Aes v-show="isAes" />

			<getApiToken v-show="isGetApiToken" />
			<refreshApiToken v-show="isRefreshApiToken" />
			<BindingDevice v-show="isBindingDevice" />

			<getToken v-show="isGetToken" />
			<decryptionCommand v-show="isDecryptionCommand" />
			<getUnLock v-show="isGetUnLock" />
			<getLock v-show="isGetLock" />

			<getImmediateVibration v-show="isGetImmediateVibration" />
			<getStop v-show="isGetStop" />
			<getTimedVibration v-show="isGetTimedVibration" />
			<getCancelTimedVibration v-show="isGetCancelTimedVibration" />

			<getElectricshock v-show="isGetElectricshock" />
			<getStopElectric v-show="isGetStopElectric" />
			<getTimeElectricshock v-show="isGetTimeElectricshock" />
			<getTimeCellElectricshock v-show="isGetTimeCellElectricshock" />
			
			<getOffline v-show="isGetOffline" />
			

		</main>
	</div>
</template>

<script>
	import introduce from '../analplug2/item/introduce.vue'; //介绍
	import steps from '../analplug2/item/steps.vue'; //步骤介绍
	import Aes from '../current/Aes.vue'; //加解密

	import getApiToken from '../current/getApiToken.vue'; //获取ApiToken
	import refreshApiToken from '../current/refreshApiToken.vue'; //刷新ApiToken
	import BindingDevice from '../current/BindingDevice.vue'; //绑定设备

	import getToken from '../analplug2/item/getToken.vue'; //获取token
	import decryptionCommand from '../analplug2/item/decryptionCommand.vue'; //解密蓝牙命令
	import getUnLock from '../analplug2/item/getUnLock.vue'; //获取开锁命令
	import getLock from '../analplug2/item/getLock.vue'; //获取关锁命令

	import getImmediateVibration from '../analplug2/item/getImmediateVibration.vue'; //立即震动
	import getStop from '../analplug2/item/getStop.vue'; //停止震动
	import getTimedVibration from '../analplug2/item/getTimedVibration.vue'; //设置定时震动
	import getCancelTimedVibration from '../analplug2/item/getCancelTimedVibration.vue'; //取消定时震动

	import getElectricshock from '../analplug2/item/getElectricshock.vue'; //立即电击
	import getStopElectric from '../analplug2/item/getStopElectric.vue'; //停止电击
	import getTimeElectricshock from '../analplug2/item/getTimeElectricshock.vue'; //定时电击
	import getTimeCellElectricshock from '../analplug2/item/getTimeCellElectricshock.vue'; //清除定时电击
	
	import getOffline from '../analplug2/item/getOffline.vue'; //设置离线模式

	export default {
		mounted() {
			const userLanguage = navigator.language || navigator.userLanguage; // 获取用户浏览器所配置的语言偏好
			const isLanguageSupported = this.$p_languages.includes(userLanguage); // 检查用户语言是否在支持的语言列表中
			this.$i18n.locale = isLanguageSupported ? userLanguage : this.$p_defaultLanguage; // 设置语言
		},
		components: {
			introduce,
			steps,
			Aes,
			getApiToken,
			refreshApiToken,
			BindingDevice,
			getToken,
			decryptionCommand,
			getUnLock,
			getLock,
			getImmediateVibration,
			getStop,
			getTimedVibration,
			getCancelTimedVibration,
			getElectricshock,
			getStopElectric,
			getTimeElectricshock,
			getTimeCellElectricshock,
			getOffline
		},
		computed: {},
		data() {
			return {
				isIntroduce: true,
				isSteps: false,
				isAes: false,
				isGetApiToken: false,
				isRefreshApiToken: false,
				isBindingDevice: false,
				isGetToken: false,
				isDecryptionCommand: false,
				isGetUnLock: false,
				isGetLock: false,
				isGetImmediateVibration: false,
				isGetStop: false,
				isGetTimedVibration: false,
				isGetCancelTimedVibration: false,
				isGetElectricshock: false,
				isGetStopElectric: false,
				isGetTimeElectricshock: false,
				isGetTimeCellElectricshock: false,
				isGetOffline: false,
				logoUrl: require('../../../../assets/app_logo.jpg'),
			};
		},
		methods: {
			toggleCategory(index) {
				this.isIntroduce = index === 1;
				this.isAes = index === 2;
				this.isGetApiToken = index === 3;
				this.isGetToken = index === 4;
				this.isGetUnLock = index === 5;
				this.isGetLock = index === 6;
				this.isBindingDevice = index === 7;
				this.isSteps = index === 8;
				this.isDecryptionCommand = index === 9;
				this.isGetImmediateVibration = index === 10;
				this.isRefreshApiToken = index === 11;
				this.isGetStop = index === 12;
				this.isGetTimedVibration = index === 13;
				this.isGetCancelTimedVibration = index === 14;
				this.isGetElectricshock = index === 15;
				this.isGetStopElectric = index === 16;
				this.isGetTimeElectricshock = index === 17;
				this.isGetTimeCellElectricshock = index === 18;
				this.isGetOffline = index === 19;
				


				window.scrollTo(0, 0); // 切换时回到顶部

			},
			//...
		},
	};
</script>

<style scoped>
</style>